var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333313 18.3335C0.333313 16.5654 1.03569 14.8697 2.28593 13.6195C3.53618 12.3692 5.23187 11.6668 6.99998 11.6668C8.76809 11.6668 10.4638 12.3692 11.714 13.6195C12.9643 14.8697 13.6666 16.5654 13.6666 18.3335H12C12 17.0074 11.4732 15.7356 10.5355 14.798C9.59783 13.8603 8.32606 13.3335 6.99998 13.3335C5.6739 13.3335 4.40213 13.8603 3.46445 14.798C2.52676 15.7356 1.99998 17.0074 1.99998 18.3335H0.333313ZM6.99998 10.8335C4.23748 10.8335 1.99998 8.596 1.99998 5.8335C1.99998 3.071 4.23748 0.833496 6.99998 0.833496C9.76248 0.833496 12 3.071 12 5.8335C12 8.596 9.76248 10.8335 6.99998 10.8335ZM6.99998 9.16683C8.84165 9.16683 10.3333 7.67516 10.3333 5.8335C10.3333 3.99183 8.84165 2.50016 6.99998 2.50016C5.15831 2.50016 3.66665 3.99183 3.66665 5.8335C3.66665 7.67516 5.15831 9.16683 6.99998 9.16683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9de6096837335b24b7c2c19ed728a823.svg";
export { ForwardRef as ReactComponent };